module.exports = __webpack_public_path__ + "img/pnu_gallery2.d4e21e9a.jpg";